module.exports = ".full-width{width:100%}\n"